import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { tap } from 'rxjs';

import { selectUrl } from '@lockton-apps/shared/data-access/router';

@Injectable()
export class CoreEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private gtmService: GoogleTagManagerService
  ) {}

  trackPageView$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        concatLatestFrom(() => this.store.select(selectUrl)),
        tap(([, url]) => {
          this.gtmService.pushTag({ event: 'page_view', page: url });
        })
      ),
    { dispatch: false }
  );
}
